/**
 * Created by abbeymart on 2016-12-26.
 */
import type { RouteRecordRaw } from 'vue-router';

export const kBaseRoutes: Array<RouteRecordRaw> = [
  {
    path: '/kBase',
    name: 'kBase',
    component: () => import('pages/central/common/KnowledgeBase.vue'),
    meta: {
      title: 'Knowledge Base',
    },
  },
];
